// Наше меню
const sampleBurgers = {
  burger1: {
    name: 'Чизбургер',
    image: '/images/cheese.jpg',
    desc:
      'Классический бургер с бифштексом из 100% говядины с маринованными огурчиками и свежей пшеничной булочкой.',
    price: 110,
    status: 'available'
  },

  burger2: {
    name: 'Чикенбургер',
    image: '/images/chicken.jpg',
    desc:
      'Куриный бургер с добавлением расплавленного сыра, соуса Барбекю и листового салата.',
    price: 140,
    status: 'available'
  },

  burger3: {
    name: 'Двойной Гамбургер',
    image: '/images/double.jpg',
    desc:
      'Двойной гамбургер с бифштексом из 100% говядины и расплавленным сыром Чеддер и пряным соусом.',
    price: 200,
    status: 'available'
  },

  burger4: {
    name: 'Фишбургер',
    image: '/images/fish.jpg',
    desc:
      'Рыбное филе высшего качества c листовым салатом, маринованными огурчиками и преправленное легким майонезом.',
    price: 150,
    status: 'available'
  },

  burger5: {
    name: 'Картофель Фри',
    image: '/images/fries.jpg',
    desc:
      'Хрустящие ломтики золотистого горячего картофеля Супер Фри, сделанные из отборного органического корнеплода!',
    price: 85,
    status: 'available'
  },

  burger6: {
    name: 'King Бургер',
    image: '/images/ham.jpg',
    desc:
      'Бургер из 100% отборной говядины, с жаренными ломтиками бекона и свежим расплавленным сыром, заправленный кетчупом и майонезом.',
    price: 450,
    status: 'available'
  },

  burger7: {
    name: 'Мега Бургер',
    image: '/images/mega.jpg',
    desc:
      'Наш самый большой бургер, сделанный из свежайшего бифштекса, с добавлением расплавленного сыра Чеддер и соленых огурчиков.',
    price: 500,
    status: 'available'
  },

  burger8: {
    name: 'Бургер в Пите',
    image: '/images/pita.jpg',
    desc:
      'Четыре котлеты из 100% говядины, покрытые плавленным сыром Чеддер, со свежим листовым салатом в свежей пшеничной лепешке.',
    price: 380,
    status: 'available'
  },

  burger9: {
    name: 'Village Фри',
    image: '/images/bakedFries.jpg',
    desc:
      'Порция свежих ломтиков картофеля, запеченых на открытом воздухе под мирно тлеющими углями',
    price: 90,
    status: 'available'
  }
};

export default sampleBurgers;
